import { Component, ElementRef, Inject, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiDataService, IApiResultObject } from './services/api-data.service';
import { IPager } from './uicomponents/pager.component';
import { DOCUMENT } from '@angular/common';

interface ITerritirySelectItem {
    Name: string,
    Id: string
}

interface IRespStorWarehouses {
    Address: string,
    Name: string,
    Id: string,
    RegionId: string,
    RegionName: string,
    CityId: string,
    CityName: string,
    Price: number | null,
    FreeArea: number | null
}

@Component({
    selector: 'representative-stores',
    template: require('./app.component.repres-stores.html'),
    styles: [require('./app.component.repres-stores.css')],
    providers: [ApiDataService]
})
export class RepresentativeStoresComponent {

    private culture: string = 'uk';
    private cityId: string = null;
    private regionId: string = null;

    private init: IApiResultObject = null;
    private pager: IPager;

    private regions: ITerritirySelectItem[] = [];
    private cities: ITerritirySelectItem[] = [];
    private warehouses: IRespStorWarehouses[] = [];
    private warehousesToShow: IRespStorWarehouses[] = [];

    constructor(private translate: TranslateService, private apiDataService: ApiDataService, private elementRef: ElementRef,
                @Inject(DOCUMENT) private document: Document, private renderer: Renderer2) {
        this.culture = this.elementRef.nativeElement.getAttribute('culture');
        translate.setDefaultLang(this.culture);

        this.pager = {} as IPager;
        this.pager.page = 1;
        this.pager.countOnPage = 10;

        this.init = {} as IApiResultObject;
        this.init.data = [];
    }

    ngOnInit(): void {
        this.GetRegions();
        this.GetCities(null);
        this.GetWarehouses();
    }

    initPager(): void {
        this.pager.totalRow = this.warehouses.length;
        this.pager.totalPages = Math.ceil(this.pager.totalRow / this.pager.countOnPage);
        this.pager.indexStart = (this.pager.page - 1) * this.pager.countOnPage + 1;
        this.pager.indexEnd = Math.min(this.pager.indexStart + this.pager.countOnPage - 1, this.pager.totalRow);
        this.pager = Object.assign({}, this.pager);
        this.GetWarehousesToShow();
    }

    onPageChanged(id: number): void {
        this.pager.page = id;
        this.pager.indexStart = (this.pager.page - 1) * this.pager.countOnPage + 1;
        this.pager.indexEnd = Math.min(this.pager.indexStart + this.pager.countOnPage - 1, this.pager.totalRow);
        this.pager = Object.assign({}, this.pager);
        this.GetWarehousesToShow();
    }

    GetWarehousesToShow(): void {
        this.warehousesToShow = [];
        for (let i = this.pager.indexStart - 1; i < this.pager.indexEnd; i++) {
            this.warehousesToShow.push(this.warehouses[i]);
        }
    }

    GetRegions(): void {
        this.apiDataService.Get("/" + this.culture + "/Representatives/GetRegionsRS")
            .subscribe(d => {
                this.init = d as IApiResultObject;
                if (this.init.status)
                    this.regions = this.init.data;
                else
                    alert(this.init.message);
            });
    }

    GetCities(regionId: string): void {
        this.cities = [];
        this.cityId = null;
        this.regionId = regionId;
        this.ajaxLoaderStart();
        this.apiDataService.Get("/" + this.culture + "/Representatives/GetCitiesRS?regionId=" + regionId)
            .subscribe(d => {
                this.ajaxLoaderEnd();
                this.init = d as IApiResultObject;
                if (this.init.status)
                    this.cities = this.init.data;
                else
                    alert(this.init.message);
            });
    }

    CityChange(cityId: string) {
        this.cityId = cityId;
    }

    GetWarehouses(): void {
        this.warehouses = [];
        this.ajaxLoaderStart();
        this.apiDataService.Get(`/${this.culture}/Representatives/GetWarehousesRS?regionId=${this.regionId}&cityId=${this.cityId}`)
            .subscribe(d => {
                this.ajaxLoaderEnd();
                this.init = d as IApiResultObject;
                if (this.init.status) {
                    this.warehouses = this.init.data;
                    this.pager.page = 1;
                    this.initPager();
                }
                else
                    alert(this.init.message);
            });
    }

    ajaxLoaderStart(): void {
        const element = this.document.querySelector('.loading');
        if (element) {
            this.renderer.addClass(element, 'loaded-show');
        }
    }

    ajaxLoaderEnd(): void {
        const element = this.document.querySelector('.loading');
        if (element) {
            this.renderer.removeClass(element, 'loaded-show');
        }
    }
}